const getTemplate = event => `
<div class="modal-header ps-card border-b border-light justify-between">
  <div>
    <h4 class="modal-title text-highlight mb-0">${event.title}</h4>
    ${
      event.extendedProps.organizer
        ? `<p class="mb-0 text-md mt-1">
        by <a href="#!">${event.extendedProps.organizer}</a>
      </p>`
        : ''
    }
  </div>
  <button type="button" class="btn p-1 font-black" data-bs-dismiss="modal" aria-label="Close">
    <span class='fas fa-times text-base'></span>
  </button>

</div>

<div class="modal-body px-card pb-card pt-1 text-md">
  ${
    event.extendedProps.description
      ? `
      <div class="mt-4 border-b pb-4 border-light">
        <h5 class='mb-0 text-muted'>Description</h5>
        <p class="mb-0 mt-2">
          ${event.extendedProps.description.split(' ').slice(0, 30).join(' ')}
        </p>
      </div>
    `
      : ''
  } 
  <div class="mt-6 ${
    event.extendedProps.location ? 'border-b pb-4 border-light' : ''
  }">
    <h5 class='mb-0 text-muted'>Date and Time</h5>
    <p class="mb-1 mt-2">
    ${
      window.dayjs &&
      window.dayjs(event.start).format('dddd, MMMM D, YYYY, h:mm A')
    } 
    ${
      event.end
        ? `– ${
            window.dayjs &&
            window
              .dayjs(event.end)
              .subtract(1, 'day')
              .format('dddd, MMMM D, YYYY, h:mm A')
          }`
        : ''
    }
  </p>

  </div>
  ${
    event.extendedProps.location
      ? `
        <div class="mt-6 ">
          <h5 class='mb-0 text-muted'>Location</h5>
          <p class="mb-0 mt-2">${event.extendedProps.location}</p>
        </div>
      `
      : ''
  }
  ${
    event.schedules
      ? `
      <div class="mt-6">
        <h5 class='mb-0 text-muted'>Schedule</h5>
        <ul class="list-none timeline mt-2 mb-0">
          ${event.schedules
            .map(schedule => `<li>${schedule.title}</li>`)
            .join('')}
        </ul>
      </div>
      `
      : ''
  }
  </div>
</div>

<div class="modal-footer flex justify-end gap-2 px-card pt-0 border-t-0">
  <a href="#!" class="btn btn-phoenix-secondary btn-sm">
    <span class="fas fa-pencil-alt text-sm mr-2"></span> Edit
  </a>
  <button class="btn btn-phoenix-danger btn-sm" data-calendar-event-remove >
    <span class="fa-solid fa-trash text-md mr-2" data-fa-transform="shrink-2"></span> Delete
  </button>
  <a href='#!' class="btn btn-primary btn-sm">
    See more details
    <span class="fas fa-angle-right text-sm ml-1"></span>
  </a>
</div>
`;

export default getTemplate;
